import React from 'react';
import './TextForm.css';

const TextForm = ({ 
  label, 
  name, 
  value, 
  onChange, 
  required = false, 
  type = 'text',
  placeholder = '',
  multiline = false,
  className = '',
  error
}) => {
  return (
    <div className={`text-form ${className} ${error ? 'has-error' : ''}`}>
      <label className="text-form-label">
        {label}
        {required && <span className="required">*</span>}
      </label>
      <div className="input-container">
        {multiline ? (
          <textarea
            name={name}
            value={value}
            onChange={onChange}
            required={required}
            placeholder={placeholder}
            className={`text-form-input text-form-textarea ${error ? 'input-error' : ''}`}
          />
        ) : (
          <input
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            required={required}
            placeholder={placeholder}
            className={`text-form-input ${error ? 'input-error' : ''}`}
          />
        )}
      </div>
      <div className="field-feedback">
        {error ? <span className="field-error">{error}</span> : <span className="field-error" style={{ visibility: 'hidden' }}>&nbsp;</span>}
      </div>
    </div>
  );
};

export default TextForm; 